// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__yk3sf","topBottomGutter":"Layout_topBottomGutter__1yK0g"};